// For more help visit https://formspr.ee/react-help
import React from 'react';
import { TiTick } from "react-icons/ti";
import { useForm, ValidationError } from '@formspree/react';

function ContactForm() {
    const [state, handleSubmit] = useForm("myylzwgz");
    if (state.succeeded) {
        return (
            <section id="contact">
                <header className="section-header">
                    <h1>Thanks! We'll respond as soon as we can.</h1>
                    <TiTick />
                    <p>In the meantime, enjoy this free .gif</p>
                </header>
                <div className="section-content">
                    <img src="https://media.giphy.com/media/3oEjI53nBYOOEQgDcY/giphy.gif?cid=ecf05e47hq1tf32jagz4tlwp5bkq48o1194kqraedqwhnlhl&rid=giphy.gif&ct=g" alt=" " />
                </div>
            </section>
        );

    }
    return (
        <section id="contact">
            <header className="section-header">
                <h1>Contact</h1>
                <p>Use the form below to contact us for more information. We'll reply as quickly as we can.</p>
            </header>

            <div className="section-content">
                <form onSubmit={handleSubmit}>
                    <label htmlFor="email">
                        <h3>Email Address</h3>
                    </label>
                    <input
                        id="email"
                        type="email"
                        name="email"
                        placeholder="enter your email address"
                        required="true"
                    />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}

                    />
                     <label htmlFor="email">
                        <h3>Message</h3>
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="enter your message"
                        required="true"

                    />
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                    <button class="submit" type="submit" disabled={state.submitting}>
                        Submit
                    </button>
                </form>
            </div>
        </section>
    );
}
function App() {
    return (
        <ContactForm />
    );
}
export default App;


// WEBPACK FOOTER //
// ./src/components/Contact.js